import React from 'react';
import ActionMenu, { ActionMenuType } from '../../ActionMenu';

interface CommentActionMenuProps {
  id: string;
  isSelf: boolean;
  viewed?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onViewed: (markAsViewed: boolean) => void;
}

enum CommentMenuActions {
  Edit = 'Edit',
  MarkUnviewed = 'Mark as unread',
  CopyLink = 'Copy link',
  Delete = 'Delete',
}

const CommentActionMenu = ({
  id,
  isSelf,
  viewed = false,
  onEdit,
  onDelete,
  onViewed,
}: CommentActionMenuProps) => {
  const reduceActions = (action: string) => {
    switch (action) {
      case CommentMenuActions.Edit:
        onEdit();
        break;
      case CommentMenuActions.Delete:
        onDelete();
        break;
      case CommentMenuActions.MarkUnviewed:
        onViewed(false);
        break;
      default:
        break;
    }
  };

  const permissions = {
    [CommentMenuActions.Edit]: {
      show: isSelf,
      disabled: false,
    },
    [CommentMenuActions.MarkUnviewed]: {
      show: viewed,
      disabled: false,
    },
    [CommentMenuActions.CopyLink]: {
      show: false,
      disabled: false,
    },
    [CommentMenuActions.Delete]: {
      show: isSelf,
      disabled: false,
    },
  };

  /**
   * If no options to show, just render div to maintain height
   */
  if (Object.values(permissions).every(permission => !permission.show)) {
    return <div style={{ height: 32, width: 32 }} />;
  }

  return (
    <ActionMenu
      id={`wsl-comment-menu-${id}`}
      classes={{ iconButton: 'wsl-comment-menu-trigger' }}
      aria-label={`Open comment actions`}
      actions={CommentMenuActions}
      onClick={reduceActions}
      PermissionsRecord={permissions}
      IconRecord={{}}
      MenuRecord={{
        [CommentMenuActions.Delete]: ActionMenuType.destructive,
      }}
      iconFontSize="inherit"
      portal={false}
    />
  );
};

export default CommentActionMenu;
